// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VenueTopPapers_venue-top-papers__DeB8o {
  display: flex;
  flex-direction: column;
}
.VenueTopPapers_venue-top-papers__DeB8o .VenueTopPapers_publication__RR82n {
  margin-bottom: 25px;
}
.VenueTopPapers_venue-top-papers__DeB8o .VenueTopPapers_publication__RR82n .VenueTopPapers_coauthors__pg\\+ds {
  margin-bottom: 3px;
  color: var(--dark-grey);
}
.VenueTopPapers_venue-top-papers__DeB8o .VenueTopPapers_publication__RR82n .VenueTopPapers_coauthors__pg\\+ds span {
  margin-right: 10px !important;
  font-style: italic;
}
.VenueTopPapers_venue-top-papers__DeB8o .VenueTopPapers_publication__RR82n .VenueTopPapers_title__fmDk9 {
  margin-bottom: 3px;
}
.VenueTopPapers_venue-top-papers__DeB8o .VenueTopPapers_publication__RR82n .VenueTopPapers_title__fmDk9 .VenueTopPapers_paper-title__UuL\\+D {
  font-weight: bold;
  cursor: pointer;
}
.VenueTopPapers_venue-top-papers__DeB8o .VenueTopPapers_publication__RR82n .VenueTopPapers_title__fmDk9 .VenueTopPapers_paper-title__UuL\\+D:hover {
  text-decoration: underline;
  color: var(--blue);
}
.VenueTopPapers_venue-top-papers__DeB8o .VenueTopPapers_publication__RR82n .VenueTopPapers_title__fmDk9 .VenueTopPapers_venue__YWQ-T {
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/VenueDetail/Components/VenueTopPapers/VenueTopPapers.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AAAE;EACE,mBAAA;AAEJ;AADI;EACE,kBAAA;EACA,uBAAA;AAGN;AAFM;EACE,6BAAA;EACA,kBAAA;AAIR;AADI;EACE,kBAAA;AAGN;AAFM;EACE,iBAAA;EACA,eAAA;AAIR;AAFM;EACE,0BAAA;EACA,kBAAA;AAIR;AAFM;EACE,kBAAA;AAIR","sourcesContent":[".venue-top-papers {\n  display: flex;\n  flex-direction: column;\n  .publication {\n    margin-bottom: 25px;\n    .coauthors {\n      margin-bottom: 3px;\n      color: var(--dark-grey);\n      span {\n        margin-right: 10px !important;\n        font-style: italic;\n      }\n    }\n    .title {\n      margin-bottom: 3px;\n      .paper-title {\n        font-weight: bold;\n        cursor: pointer;\n      }\n      .paper-title:hover {\n        text-decoration: underline;\n        color: var(--blue);\n      }\n      .venue {\n        font-style: italic;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"venue-top-papers": `VenueTopPapers_venue-top-papers__DeB8o`,
	"publication": `VenueTopPapers_publication__RR82n`,
	"coauthors": `VenueTopPapers_coauthors__pg+ds`,
	"title": `VenueTopPapers_title__fmDk9`,
	"paper-title": `VenueTopPapers_paper-title__UuL+D`,
	"venue": `VenueTopPapers_venue__YWQ-T`
};
export default ___CSS_LOADER_EXPORT___;
